import React from 'react'
import { Box, styled } from '@mui/material'
import { VisibilityOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { formatVersionLabel } from './projectVersion.action'
import { RevisionConfigure } from './useRevisionConfigure'

// Tells that the map shows the published version, which cannot be edited from here.
export const RevisionViewNote: React.FC<{ revision: RevisionConfigure }> = ({ revision }) => {
  const { t } = useTranslation(['projects'])
  if (revision.view !== 'before') return null
  return (
    <Note>
      <VisibilityOutlined sx={{ fontSize: 15 }} />
      {t('revision-showing-published', {
        ns: 'projects',
        version: formatVersionLabel(revision.changes?.baseVersionNumber ?? 0),
      })}
    </Note>
  )
}

export default RevisionViewNote

const Note = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: 10,
  top: 10,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.625, 1.25),
  borderRadius: 4,
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  backgroundColor: 'rgba(255,255,255,.94)',
  fontSize: 12,
  color: getThemeColor(theme, MUIThemeColors.secondaryDark),
  pointerEvents: 'none',
}))
